export enum PatientSourceEnum {
  MedconnectPatient = 'MedconnectPatient',
  NetsoinsPatient = 'NetsoinsPatient',
}
